__turbopack_context__.v({
  "Kinoklubb": "_62N5Na_Kinoklubb",
  "PosterMissing": "_62N5Na_PosterMissing",
  "SPremActions": "_62N5Na_SPremActions",
  "SPremiere": "_62N5Na_SPremiere",
  "STicketButton": "_62N5Na_STicketButton",
  "SWLPoster": "_62N5Na_SWLPoster",
  "ThemeDk": "_62N5Na_ThemeDk",
  "ThemeFw": "_62N5Na_ThemeFw",
  "TopWatchlistButton": "_62N5Na_TopWatchlistButton",
});
